import { BaseSceneEventsController } from "./_BaseEventsController";
import { CoreEventEmitter } from "../../../viewers/utils/ViewerEventsController";
import { CursorHelper } from "../../../nodes/event/utils/CursorHelper";
import { Raycaster, Vector2 } from "three";
var PointerEventType = /* @__PURE__ */ ((PointerEventType2) => {
  PointerEventType2["pointerdown"] = "pointerdown";
  PointerEventType2["pointermove"] = "pointermove";
  PointerEventType2["pointerup"] = "pointerup";
  return PointerEventType2;
})(PointerEventType || {});
export const ACCEPTED_POINTER_EVENT_TYPES = [
  "pointerdown" /* pointerdown */,
  "pointermove" /* pointermove */,
  "pointerup" /* pointerup */
];
const ACTOR_EVENT_DATA_POINTERMOVE = {
  type: "pointermove" /* pointermove */,
  emitter: CoreEventEmitter.CANVAS
};
const ACTOR_EVENT_DATA_POINTERDOWN = {
  type: "pointerdown" /* pointerdown */,
  emitter: CoreEventEmitter.CANVAS
};
const ACTOR_EVENT_DATA_POINTERUP = {
  type: "pointerup" /* pointerup */,
  emitter: CoreEventEmitter.CANVAS
};
const ACTOR_EVENT_DATA = {
  ["pointermove" /* pointermove */]: ACTOR_EVENT_DATA_POINTERMOVE,
  ["pointerdown" /* pointerdown */]: ACTOR_EVENT_DATA_POINTERDOWN,
  ["pointerup" /* pointerup */]: ACTOR_EVENT_DATA_POINTERUP
};
export class PointerEventsController extends BaseSceneEventsController {
  constructor() {
    super(...arguments);
    this._requireCanvasEventListeners = true;
    this._cursorHelper = new CursorHelper();
    this._cursor = new Vector2();
    this._raycaster = new Raycaster();
  }
  type() {
    return "pointer";
  }
  acceptedEventTypes() {
    return new Set(ACCEPTED_POINTER_EVENT_TYPES.map((n) => `${n}`));
  }
  processEvent(eventContext) {
    super.processEvent(eventContext);
    const { viewer, event } = eventContext;
    if (this._actorEventNames.size == 0) {
      return;
    }
    if (!(event && viewer)) {
      return;
    }
    const eventType = event.type;
    if (!this._actorEventNames.has(eventType)) {
      return;
    }
    this._camera = viewer.camera();
    this._cursorHelper.setCursorForCPU(eventContext, this._cursor);
    if (this._camera) {
      viewer.raycaster.setFromCamera(this._cursor, this._camera);
      this._raycaster = viewer.raycaster;
    }
    const nodesToTrigger = this._actorNodesByEventNames.get(eventType);
    if (nodesToTrigger) {
      this.dispatcher.scene.actorsManager.pointerEventsController.setTriggeredNodes(nodesToTrigger);
    }
  }
  _actorEventDatas() {
    const eventDatas = [];
    this._actorEventNames.forEach((eventName) => {
      const eventData = ACTOR_EVENT_DATA[eventName];
      if (eventData) {
        eventDatas.push(eventData);
      }
    });
    return eventDatas;
  }
  raycaster() {
    return this._raycaster;
  }
  updateRaycast(options) {
    if (!this._raycaster) {
      return;
    }
    const pointsParam = this._raycaster.params.Points;
    if (pointsParam) {
      pointsParam.threshold = options.pointsThreshold;
    }
    const lineParam = this._raycaster.params.Line;
    if (lineParam) {
      lineParam.threshold = options.lineThreshold;
    }
  }
}
